// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`FormValidator test Match con el snapshot 1`] = `<form novalidate="novalidate" autocomplete="off"></form>`;
